<template>
  <main :class="$i18n.locale" class="relative">
    <LayoutsHeader />
    <slot />
    <LayoutsFooter />
  </main>
</template>
